import { inject } from 'aurelia';
import { LanguageHelper } from '../../infrastructure/language-helper';
import { ProjectDraftStorageService } from '../../services/project-draft-storage-service';

@inject(ProjectDraftStorageService)
export class LoginModal {
    constructor(private readonly _projectDraftStorageService: ProjectDraftStorageService) {}

    public signIn(provider: string): void {
        this._projectDraftStorageService.saveDraft();
        const language = LanguageHelper.resolveCurrentLanguage(window.location.pathname, document.cookie);
        const langPath = `/${language}/app/`;
        const returnUrl = `${window.location.origin}${langPath}`;
        window.location.href = `/auth/signin/${provider}?returnUrl=${encodeURIComponent(returnUrl)}`;
    }
}
